/**
 * 路由封装
 * 路由懒加载方式一：
 *    1. component: resolve => require(['../pages/Index.vue'],resolve)  // 路由懒加载
 * 路由懒加载方式二：
 *    1. 需要添加 syntax-dynamic-import (opens new window)插件，才能使 Babel 可以正确地解析语法,`cnpm install --save-dev @babel/plugin-syntax-dynamic-import`
 *    2. component: () => import('../pages/Cart.vue'), // 路由懒加载
 */
// 导入vue和vue-router
import Vue from 'vue'
import Router from 'vue-router'
// 导入页面组件
import Home from '../pages/Home'
import Index from '../pages/HomePage/Index'
import PersonalCenter from '../pages/PersonalCenter'
import UserInfo from '../pages/UserInfo/UserInfo'
// 加载路由插件
Vue.use(Router)
// 导出路由
const router = new Router({
  // 路由规则
  routes: [
    // 引导页
    {
      path: '/guide',
      name: 'guide',
      // component: Login
      component: () => import('../pages/Guide.vue') // 路由懒加载
    },
    // 首页
    {
      path: '/index',
      name: 'index',
      // component: Login
      component: () => import('../pages/Home.vue') // 路由懒加载
    },
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home,
    //   redirect: '/index', // 重定向
    //   // 子路由
    //   children: [
    //     {
    //       path: 'index',
    //       name: 'index',
    //       component: Index,
    //     }
    //   ]
    // },
    // 登录
    {
      path: '/login',
      name: 'login',
      // component: Login
      component: () => import('../pages/Login.vue') // 路由懒加载
    },
    // 商品列表
    {
      path: '/goodsList',
      name: 'goodsList',
      component: () => import('../pages/HomePage/GoodsList') // 路由懒加载
    },
    // 首页分组商品列表
    {
      path: '/layoutGoodsList',
      name: 'layoutGoodsList',
      component: () => import('../pages/HomePage/LayoutGoodsList.vue') // 路由懒加载
    },
    // 限时特惠
    {
      path: '/specialList',
      name: 'specialList',
      component: () => import('../pages/DiscountPage/SpecialList.vue') // 路由懒加载
    },
    {
      path: '/specialDetail',
      name: 'specialDetail',
      component: () => import('../pages/DiscountPage/SpecialDetail.vue') // 路由懒加载
    },
    // 限时秒杀
    {
      path: '/seckillList',
      name: 'seckillList',
      component: () => import('../pages/DiscountPage/SeckillList.vue') // 路由懒加载
    },
    // 特价拼团
    {
      path: '/groupList',
      name: 'groupList',
      component: () => import('../pages/DiscountPage/GroupList.vue') // 路由懒加载
    },
    {
      path: '/groupDetail',
      name: 'groupDetail',
      component: () => import('../pages/DiscountPage/GroupDetail.vue') // 路由懒加载
    },
    {
      path: '/groupConfirmOrder',
      name: 'groupConfirmOrder',
      component: () => import('../pages/DiscountPage/GroupConfirmOrder.vue') // 路由懒加载
    },
    // 积分商品列表
    {
      path: '/integralList',
      name: 'integralList',
      component: () => import('../pages/HomePage/IntegralList.vue') // 路由懒加载
    },
    // 品牌列表
    {
      path: '/brandList',
      name: 'brandList',
      component: () => import('../pages/HomePage/BrandList.vue') // 路由懒加载
    },
    // 活动分组列表
    {
      path: '/activityGroup',
      name: 'activityGroup',
      component: () => import('../pages/HomePage/ActivityGroup.vue') // 路由懒加载
    },
    // 活动商品列表
    {
      path: '/activityList',
      name: 'activityList',
      component: () => import('../pages/HomePage/ActivityList.vue') // 路由懒加载
    },
    // 栏目商品列表
    {
      path: '/columnList',
      name: 'columnList',
      component: () => import('../pages/HomePage/ColumnList.vue') // 路由懒加载
    },
    // 栏目分类商品列表
    {
      path: '/columnGoodsList',
      name: 'columnGoodsList',
      component: () => import('../pages/HomePage/ColumnGoodsList.vue') // 路由懒加载
    },
    // 商品详情
    {
      path: '/detail',
      name: 'detail',
      component: () => import('../pages/HomePage/Detail.vue') // 路由懒加载
    },
    // 商品详情（二三类的，外联点击进入，不需要登录）
    {
      path: '/columnDetail',
      name: 'columnDetail',
      component: () => import('../pages/HomePage/columnDetail.vue') // 路由懒加载
    },

    // 京东专区
    {
      path: '/jdList',
      name: 'jdList',
      component: () => import('../pages/JdPage/JdList.vue') // 路由懒加载
    },
    {
      path: '/jdDetail',
      name: 'jdDetail',
      component: () => import('../pages/JdPage/JdDetail.vue') // 路由懒加载
    },
    {
      path: '/jdConfirmOrder',
      name: 'jdConfirmOrder',
      component: () => import('../pages/JdPage/JdConfirmOrder.vue') // 路由懒加载
    },
    // 蛋糕专区
    {
      path: '/cakeList',
      name: 'cakeList',
      component: () => import('../pages/CakePage/CakeList.vue') // 路由懒加载
    },
    {
      path: '/cakeDetail',
      name: 'cakeDetail',
      component: () => import('../pages/CakePage/CakeDetail.vue') // 路由懒加载
    },
    {
      path: '/cakeConfirmOrder',
      name: 'cakeConfirmOrder',
      component: () => import('../pages/CakePage/CakeConfirmOrder.vue') // 路由懒加载
    },
    {
      path: '/brandCakeList',
      name: 'brandCakeList',
      component: () => import('../pages/CakePage/BrandCakeList.vue') // 路由懒加载
    },
    {
      path: '/shopCakeList',  
      name: 'shopCakeList',
      component: () => import('../pages/CakePage/ShopCakeList.vue') // 路由懒加载
    },
    // 电影专区
    {
      path: '/selectSeat',
      name: 'selectSeat',
      component: () => import('../pages/MoviePage/SelectSeat.vue') // 路由懒加载
    },
    {
      path: '/movieZone',
      name: 'movieZone',
      component: () => import('../pages/MoviePage/MovieZone.vue') // 路由懒加载
    },
    {
      path: '/movieZoneDetail',
      name: 'movieZoneDetail',
      component: () => import('../pages/MoviePage/MovieZoneDetail.vue') // 路由懒加载
    },
    {
      path: '/movieConfirmOrder',
      name: 'movieConfirmOrder',
      component: () => import('../pages/MoviePage/MovieConfirmOrder.vue') // 路由懒加载
    },
    {
      path: '/moviePayOrder',
      name: 'moviePayOrder',
      component: () => import('../pages/MoviePage/MoviePayOrder.vue') // 路由懒加载
    },
    // 卡券专区
    {
      path: '/couponList',
      name: 'couponList',
      component: () => import('../pages/CouponPage/CouponList.vue') // 路由懒加载
    },
    {
      path: '/couponDetail',
      name: 'couponDetail',
      component: () => import('../pages/CouponPage/CouponDetail.vue') // 路由懒加载
    },
    {
      path: '/couponConfirmOrder',
      name: 'couponConfirmOrder',
      component: () => import('../pages/CouponPage/CouponConfirmOrder.vue') // 路由懒加载
    },
    {
      path: '/couponPayOrder',
      name: 'couponPayOrder',
      component: () => import('../pages/CouponPage/CouponPayOrder.vue') // 路由懒加载
    },
    // 公告列表
    {
      path: '/noticeList',
      name: 'noticeList',
      component: () => import('../pages/HomePage/NoticeList.vue') // 路由懒加载
    },
    // 购物车
    {
      path: '/cart',
      name: 'cart',
      // component: Cart
      component: () => import('../pages/Cart.vue') // 路由懒加载
    },
    // 个人中心
    {
      path: '/',
      name: 'personalCenter',
      component: PersonalCenter,
      redirect: '/userInfo', // 重定向
      // 子路由
      children: [
        {
          path: 'userInfo',
          name: 'userInfo',
          component: UserInfo // 路由懒加载
        },
        {
          path: 'orderList',
          name: 'orderList',
          component: () => import('../pages/UserInfo/OrderList.vue') // 路由懒加载
        },
        {
          path: 'orderDetail',
          name: 'orderDetail',
          component: () => import('../pages/UserInfo/OrderDetail.vue') // 路由懒加载
        },
        {
          path: 'cakeOrderDetail',
          name: 'cakeOrderDetail',
          component: () => import('../pages/CakePage/CakeOrderDetail.vue') // 路由懒加载
        },
        {
          path: 'jdOrderDetail',
          name: 'jdOrderDetail',
          component: () => import('../pages/JdPage/JdOrderDetail.vue') // 路由懒加载
        },
        //福利卡
        {
          path: 'benefitCard',
          name: 'benefitCard',
          component: () => import('../pages/UserInfo/BenefitCard.vue') // 路由懒加载
        },
        //专区余额记录
        {
          path: 'specialZone',
          name: 'specialZone',
          component: () => import('../pages/UserInfo/specialZone.vue') // 路由懒加载
        },
        //助农卡
        {
          path: 'agriculturalCard',
          name: 'agriculturalCard',
          component: () => import('../pages/UserInfo/AgriculturalCard.vue') // 路由懒加载
        },
        //我的卡包
        {
          path: 'cardBag',
          name: 'cardBag',
          component: () => import('../pages/UserInfo/CardBag.vue') // 路由懒加载
        },
        {
          path: 'exchangeRecord',
          name: 'exchangeRecord',
          component: () => import('../pages/UserInfo/ExchangeRecord.vue') // 路由懒加载
        },
        {
          path: 'cardTurnRecord',
          name: 'cardTurnRecord',
          component: () => import('../pages/UserInfo/CardTurnRecord.vue') // 路由懒加载
        },
        //我的积分
        {
          path: 'myIntegral',
          name: 'myIntegral',
          component: () => import('../pages/UserInfo/MyIntegral.vue') // 路由懒加载
        },
        // 资质认证
        {
          path: 'qualification',
          name: 'qualification',
          component: () => import('../pages/UserInfo/Qualification.vue') // 路由懒加载
        },
        //授信额度
        {
          path: 'lineCredit',
          name: 'lineCredit',
          component: () => import('../pages/UserInfo/LineCredit.vue') // 路由懒加载
        },
        {
          path: 'addressList',
          name: 'addressList',
          component: () => import('../pages/UserInfo/AddressList.vue') // 路由懒加载
        },
        {
          path: 'invoiceList',
          name: 'invoiceList',
          component: () => import('../pages/UserInfo/InvoiceList.vue') // 路由懒加载
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('../pages/UserInfo/Feedback.vue') // 路由懒加载
        },
        {
          path: 'browseRecord',
          name: 'browseRecord',
          component: () => import('../pages/UserInfo/BrowseRecord.vue') // 路由懒加载
        },
        {
          path: 'collectRecord',
          name: 'collectRecord',
          component: () => import('../pages/UserInfo/CollectRecord.vue') // 路由懒加载
        },
        {
          path: 'messageList',
          name: 'messageList',
          component: () => import('../pages/UserInfo/MessageList.vue') // 路由懒加载
        },
        {
          path: 'myComment',
          name: 'myComment',
          component: () => import('../pages/UserInfo/myComment.vue') // 路由懒加载
        },
        // 电影订单
        {
          path: 'movieOrderList',
          name: 'movieOrderList',
          component: () => import('../pages/MoviePage/MovieOrderList.vue') // 路由懒加载
        },
        {
          path: 'movieOrderDetail',
          name: 'movieOrderDetail',
          component: () => import('../pages/MoviePage/MovieOrderDetail.vue') // 路由懒加载
        },
        // 卡券订单
        {
          path: 'couponOrderList',
          name: 'couponOrderList',
          component: () => import('../pages/CouponPage/CouponOrderList.vue') // 路由懒加载
        },
        {
          path: 'couponOrderDetail',
          name: 'couponOrderDetail',
          component: () => import('../pages/CouponPage/CouponOrderDetail.vue') // 路由懒加载
        },
        // 售后
        {
          path: 'applyRefund',
          name: 'applyRefund',
          component: () => import('../pages/RefundPage/ApplyRefund.vue') // 路由懒加载
        },
        {
          path: 'refundOrderList',
          name: 'refundOrderList',
          component: () => import('../pages/RefundPage/RefundOrderList.vue') // 路由懒加载
        },
        {
          path: 'refundOrderDetail',
          name: 'refundOrderDetail',
          component: () => import('../pages/RefundPage/RefundOrderDetail.vue') // 路由懒加载
        },
        //商品评价
        {
          path: 'evaluateGoods',
          name: 'evaluateGoods',
          component: () => import('../pages/UserInfo/evaluateGoods.vue') // 路由懒加载
        },
      ]
    },
    // 订单
    {
      path: '/order',
      name: 'order',
      component: () => import('../pages/Order.vue'), // 路由懒加载
      children: [
        {
          path: 'confirmOrder',
          name: 'confirmOrder',
          component: () => import('../pages/OrderPage/ConfirmOrder.vue') // 路由懒加载
        },

        {
          path: 'payOrder',
          name: 'payOrder',
          component: () => import('../pages/OrderPage/PayOrder.vue') // 路由懒加载
        },
        //充值
        {
          path: 'payment',
          name: 'payment',
          component: () => import('../pages/OrderPage/Payment.vue') // 路由懒加载
        },
      ]
    },
  ]
})



export default router;
